// import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  FormControl,
  Card,
  CardContent,
  InputLabel,
  useTheme,
  useMediaQuery,
  theme,
} from "@mui/material";
import {
  addMetal,
  addKarat,
  addPurity,
  changeStatus,
  fetchKarat,
  addQuantity,
  removeQuantity,
  clearMessage,
  setKaratList,
  setError,
  getMetals,
  getPuritiesByKaratId,
  updateSellOutTime,
  downloadMetalReport,
  getMetalHistory,
  updateRedeemTimeOut,
} from "../../../redux/slices/manageMetals";

//"/src/redux/slices/src/redux/slices/manageMetals"
import Sidebar from "../../Drawer/Sidebar";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Changemetalstatetable from "./Changemetalstatetable";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import MetalBalanceHistoryTable from "./MetalBalanceHistoryTable";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import DynamicDialog from "../../Modals/CommanDialog";
import AddIcon from "@mui/icons-material/Add";
import MetalBalanceHistory from "./MetalBalanceHistory";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getAppConfig } from "../../../redux/Configuration/configurationSlice";
import { updateBullionTaxRequest } from "../../../redux/Bullion/BullionSlice";
import { canShowPermission } from "../Permissions/permissionObject";
import BullionMarginTable from "./BullionMarginTable";

const MetalManagement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const message = useSelector((state) => state?.metals?.message);
  const error = useSelector((state) => state?.metals?.error);
  const karatList = useSelector((state) => state?.metals?.karatList || []);
  const metals = useSelector((state) => state.metals?.metals || []);
  const enabledMetal = useSelector((state) => state.metals?.enabledMetal || []);
  const metalHistory = useSelector((state) => state.metals?.metalHistory || []);
  const metalHistoryTotal = useSelector(
    (state) => state.metals?.metalHistoryTotal || 0,
  );
  const configData = useSelector((state) => state.appConfig.configData);
  const taxType = configData?.taxtype || "GST";
  console.log("taxType", taxType);
  const [liveRates, setLiveRates] = useState(false);
  
  useEffect(() => {
    if (Object.keys(configData).length) {
      setLiveRates(configData?.featureToggle?.Live_Rates === true); 
    }
  }, [configData]);
  console.log("liveRates", liveRates);
  
  const purityList = useSelector((state) => state.metals.purityList);
  const state = useSelector((state) => state);
  const [metalName, setMetalName] = useState("");
  const [metalBalance, setMetalBalance] = useState({
    metalName: "",
    purity: "",
    rate: 0,
    balance: 0,
  });
  const [removeMetalBalance, setRemoveMetal] = useState({
    metalName: "",
    purity: "",
    rate: 0,
    balance: 0,
  });
  const [purity, setPurity] = useState("");
  const [status, setStatus] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bullion, selectedBullion] = useState("");
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [karatValue, setKaratValue] = useState("");
  const [purityValue, setPurityValue] = useState("");

  const [selectedKarat, setSelectedKarat] = useState("");
  const [selectedPurity, setSelectedPurity] = useState("");
  const [selectedMetal, setSelectedMetal] = useState(null);
  const [tax, setTax] = useState();
  const [cgst, setCgst] = useState();
  const [sgst, setSgst] = useState();
  const [igst, setIgst] = useState();
  const [cess, setCess] = useState();
  const states = useSelector((state) => state.metalRate?.states || []);
  const [selectedState, setSelectedState] = useState("");

  const resetTaxFields = () => {
    setTax("");
    setCgst("");
    setSgst("");
    setIgst("");
    setCess("");
  };

  const handleOpen = () => {
    setSelectedMetal("");
    setSelectedKarat("");
    setSelectedPurity("");
    resetTaxFields();
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleClick = () => {
    const karat = parseFloat(karatValue);
    if (isNaN(karat) || karat <= 0) {
      alert("Enter a valid Karat value greater than 0.");
      return;
    }
    if (karatList.includes(karat)) {
      alert("This Karat already exists.");
      return;
    }
    dispatch(
      addKarat({
        karat,
      }),
    );
    dispatch(fetchKarat());
    setKaratValue("");
  };

  const handleAddPurity = () => {
    if (!selectedKarat || !purityValue) {
      alert("Please select a karat and enter purity.");
      return;
    }
    dispatch(
      addPurity({
        karat: parseFloat(selectedKarat),
        purity: parseFloat(purityValue),
      }),
    );
    dispatch(fetchKarat());
    // Reset fields if needed
    setPurityValue("");
    setSelectedKarat("");
  };

  const handleAddMetal = () => {
    if (!selectedKarat || !selectedMetal || !selectedPurity) {
      return toast.warning("Please enter all required fields.");
    }

    if (taxType === "GST") {
      const hasCgstSgst = cgst && sgst;
      const hasIgst = igst;

      if (!hasCgstSgst || !hasIgst) {
        return toast.warning("Please enter CGST, SGST, and IGST values.");
      }
    }

    if (taxType === "VAT") {
      if (!tax) {
        return toast.warning("Tax field is required");
      }
    }

    const payload = {
      metalName: selectedMetal,
      karat: Number(selectedKarat),
      purity: parseFloat(selectedPurity),
      tax: Number(tax),
      cgst: Number(cgst),
      sgst: Number(sgst),
      igst: Number(igst),
      cess: Number(cess),
    };

    dispatch(addMetal(payload));
    resetTaxFields();
    handleClose();
  };

  const generateReport = () => {
    if (!bullion || !startDate || !endDate) {
      return alert("please select all fields");
    }

    dispatch(
      downloadMetalReport({
        bullion: bullion,
        start_date: startDate,
        end_date: endDate,
      }),
    );
  };

  const [sellOutMetal, setSellOutMetal] = useState("");
  const [sellOutPurity, setSellOutPurity] = useState("");
  const [sellOutTime, setSellOutTime] = useState("");

  const handleUpdateSellOutTime = () => {
    dispatch(
      updateSellOutTime({
        metalName: sellOutMetal,
        purity: parseFloat(sellOutPurity),
        sellOut: parseInt(sellOutTime),
      }),
    );
  };

  const [redeemTimeOutMetal, setRedeemTimeOutMetal] = useState("");
  const [redeemTimeOutPurity, setRedeemTimeOutPurity] = useState("");
  const [redeemTimeOut, setRedeemTimeOut] = useState("");

  const handleUpdateRedeemTimeOut = () => {
    dispatch(
      updateRedeemTimeOut({
        metalName: redeemTimeOutMetal,
        purity: parseFloat(redeemTimeOutPurity),
        redeemTimeOut: parseInt(redeemTimeOut),
      }),
    );
  };

  const [balance, setBalance] = useState("");
  const [rate, setRate] = useState("");
  const totalWithoutGst =
    metalBalance.balance && metalBalance.rate
      ? metalBalance.balance * metalBalance.rate
      : 0;
  const selectedEnabledMetal = enabledMetal.find(
    (item) =>
      item.metalName === metalBalance.metalName &&
      String(item.purity) === String(metalBalance.purity),
  );
  let gst = 0;
  let totalWithGst = totalWithoutGst;

  if (selectedEnabledMetal) {
    if (taxType === "GST") {
      let gstPercent =
        Number(selectedEnabledMetal.cgst || 0) +
        Number(selectedEnabledMetal.sgst || 0);
      gst = (totalWithoutGst * gstPercent) / 100;
      totalWithGst = totalWithoutGst + gst;
    }

    if (taxType === "VAT") {
      const taxPercent = Number(selectedEnabledMetal.tax || 0);
      const cessPercent = Number(selectedEnabledMetal.cess || 0);

      const taxAmount = (totalWithoutGst * taxPercent) / 100;
      const cessAmount = (taxAmount * cessPercent) / 100;

      gst = taxAmount + cessAmount;
      totalWithGst = totalWithoutGst + gst;
    }
  }

  const totalWithoutGstRemove =
    removeMetalBalance.balance && removeMetalBalance.rate
      ? removeMetalBalance.balance * removeMetalBalance.rate
      : 0;
  const selectedEnabledMetalRemove = enabledMetal.find(
    (item) =>
      item.metalName === removeMetalBalance.metalName &&
      String(item.purity) === String(removeMetalBalance.purity),
  );
  let gstRemove = 0;
  let totalWithGstRemove = totalWithoutGstRemove;

  if (selectedEnabledMetalRemove) {
    if (taxType === "GST") {
      let gstPercentRemove =
        Number(selectedEnabledMetalRemove.cgst || 0) +
        Number(selectedEnabledMetalRemove.sgst || 0);
      gstRemove = (totalWithoutGstRemove * gstPercentRemove) / 100;
      totalWithGstRemove = totalWithoutGstRemove + gstRemove;
    }

    if (taxType === "VAT") {
      const taxPercent = Number(selectedEnabledMetalRemove.tax || 0);
      const cessPercent = Number(selectedEnabledMetalRemove.cess || 0);

      const taxAmount = (totalWithoutGstRemove * taxPercent) / 100;
      const cessAmount = (taxAmount * cessPercent) / 100;

      gstRemove = taxAmount + cessAmount;
      totalWithGstRemove = totalWithoutGstRemove + gstRemove;
    }
  }

  // const [ratePerGram, setRatePerGram] = useState("");
  // const [totalWithoutGsts, setTotalWithoutGst] = useState("");

  const handleAddQuantity = () => {
    if (
      !metalBalance.balance ||
      !metalBalance.metalName ||
      !metalBalance.purity ||
      !metalBalance.rate
    ) {
      return alert("check all fields");
    }

    dispatch(addQuantity(metalBalance));

    setMetalBalance({
      metalName: "",
      balance: 0,
      rate: 0,
      purity: "",
    });
  };

  const handleRemoveQuantity = () => {
    if (
      !removeMetalBalance.balance ||
      !removeMetalBalance.metalName ||
      !removeMetalBalance.purity ||
      !removeMetalBalance.rate
    ) {
      return alert("check all fields");
    }
    dispatch(removeQuantity(removeMetalBalance));

    setRemoveMetal({
      metalName: "",
      balance: 0,
      rate: 0,
      purity: "",
    });
  };

  useEffect(() => {
    if (selectedKarat) {
      setSelectedPurity("");
      dispatch(getPuritiesByKaratId({ karat: selectedKarat }));
    }
  }, [selectedKarat]);
  useEffect(() => {
    dispatch(fetchKarat());
    // dispatch(getMetalHistory());
    dispatch(getMetals({}));
  }, []);

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (e) {
        console.error("Invalid permissions JSON", e);
      }
    }
  }, []);

  const canCreateMetal = canShowPermission(permissions, "editMetal", "create");
  const canEdit = canShowPermission(permissions, "editMetal", "edit");
  const canDelete = canShowPermission(permissions, "editMetal", "delete");

  return (
    <Box sx={{ width: "98%", height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "100%",
          mt: 0,
        }}
      >
        {/* <Sidebar/> */}
        {/* Section 1: Karat & Purity */}
        {/* <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            Manage Karat & Purity
          </Typography>

          <Grid container spacing={3} display={"flex"}> */}
        {/* Karat Input */}
        {/* <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label="Add Karat (k)"
                size="small"
                value={karatValue}
                onChange={(e) => setKaratValue(e.target.value)}
                placeholder="Add Karat"
                sx={{
                  width: "100%",
                  minWidth: { xs: "210px", sm: "332px" },
                }}
              />
            </Grid> */}

        {/* Add Karat Button */}
        {/* <Grid item xs={12} md={4}>
            {canCreateMetal && ( <Button
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#752ADA",
                  height: "40px",
                  fontSize: "14px",
                  textTransform: "none",
                }}
                onClick={() => handleClick()}
              >
                Save
              </Button>)} 
            </Grid>
          </Grid>
          <Grid container spacing={3} mt={3}> */}
        {/* Purity Input */}
        {/* <Grid item xs={12} md={3} display={"flex"}>
              <TextField
                fullWidth
                label="Add Purity"
                size="small"
                value={purityValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    setPurityValue(value);
                  }
                }}
                placeholder="Add Purity"
                sx={{
                  width: "100%",
                  minWidth: { xs: "210px", sm: "332px" },
                }}
              />
            </Grid> */}

        {/* Karat Dropdown */}
        {/* <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Karat</InputLabel>
                <Select
                  sx={{
                    width: "100%",
                    minWidth: { xs: "210px", sm: "332px" },
                  }}
                  label="Karat"
                  value={selectedKarat}
                  onChange={(e) => setSelectedKarat(e.target.value)}
                >
                  {karatList.map((karat, idx) => (
                    <MenuItem key={idx} value={karat.karat}>
                      {karat.karat}K
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}

        {/* Add Purity Button */}
        {/* <Grid item xs={12} md={3}>
            {canCreateMetal && ( <Button
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#752ADA",
                  height: "40px",
                  fontSize: "14px",
                  textTransform: "none",
                }}
                onClick={handleAddPurity}
              >
                Save
              </Button>)} 
            </Grid>
          </Grid>
        </Paper> */}

        {/* Section 2: Change status of Metal */}
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4, mt: 3 }}>
          {" "}
          <Box sx={{ justifyContent: "space-between", display: "flex", mb: 2 }}>
            <Typography
              fontFamily={"Aeonik"}
              sx={{ fontSize: "24px", fontWeight: 700 }}
            >
              {" "}
              {t("metals.metalList")}
            </Typography>
            {canCreateMetal && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                sx={{
                  textTransform: "none",
                  background: "#7028DA",
                  fontFamily: "inherit",
                }}
                onClick={handleOpen}
              >
                {t("metals.createNewMetal")}
              </Button>
            )}
          </Box>
          <DynamicDialog
            open={open}
            onClose={handleClose}
            onSubmit={handleAddMetal}
            title={t("metals.addMetal")}
            message={
              <Grid container spacing={2} mt={1} p={2}>
                {/* Select Metal Dropdown */}
                <Grid item xs={12} md={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                  >
                    <InputLabel>{t("metals.selectMetal")}</InputLabel>
                    <Select
                      label={t("metals.selectMetal")}
                      value={selectedMetal}
                      onChange={(e) => {
                        setSelectedMetal(e.target.value);
                      }}
                    >
                      {[
                        { metalName: "Gold" },
                        { metalName: "Silver" },
                        { metalName: "Platinum" },
                        { metalName: "Product" },
                      ].map((item, index) => (
                        <MenuItem key={index} value={item.metalName}>
                          {item.metalName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                  >
                    <TextField
                      label={t("metals.enterKarat")}
                      type="text"
                      value={selectedKarat}
                      inputProps={{ maxLength: 2 }}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setSelectedKarat(value === "" ? "" : Number(value));
                        }
                      }}
                      sx={{
                        width: "100%",
                        minWidth: { xs: "210px", sm: "332px" },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                  >
                    <TextField
                      label={t("metals.enterPurity")}
                      type="text"
                      value={selectedPurity}
                      inputProps={{ maxLength: 3 }}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setSelectedPurity(value === "" ? "" : Number(value));
                        }
                      }}
                      sx={{
                        width: "100%",
                        minWidth: { xs: "210px", sm: "332px" },
                      }}
                    />
                  </FormControl>
                </Grid>
                {taxType === "VAT" && (
                  <>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label={t("metals.taxPercent")}
                        type="text"
                        value={tax}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                            setTax(value);
                          }
                        }}
                        sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label={t("metals.cessPercent")}
                        type="cess"
                        value={cess}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                            setCess(value);
                          }
                        }}
                        sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                      />
                    </Grid>
                  </>
                )}

                {taxType === "GST" && (
                  <>
                    {" "}
                    {/* CGST */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label={t("metals.cgstPercent")}
                        type="text"
                        value={cgst}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                            setCgst(value);
                          }
                        }}
                        sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                      />
                    </Grid>
                    {/* SGST */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label={t("metals.sgstPercent")}
                        type="text"
                        value={sgst}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                            setSgst(value);
                          }
                        }}
                        sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                      />
                    </Grid>
                    {/* IGST */}
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label={t("metals.igstPercent")}
                        type="text"
                        value={igst}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^(?:\d+\.?\d*|\.\d*)?$/.test(value)) {
                            setIgst(value);
                          }
                        }}
                        sx={{ minWidth: { xs: "210px", sm: "332px" } }}
                      />
                    </Grid>
                  </>
                )}
                {/* Add Button */}
              </Grid>
            }
            cancelText={t("metals.cancel")}
            submitText={t("metals.save")}
          />
          <Grid mb={10}>
            <Changemetalstatetable />
          </Grid>
          <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
            <Typography
              fontFamily={"Aeonik"}
              sx={{ fontSize: "24px", fontWeight: 700, mb: 2 }}
            >
              Bullion Margin List
            </Typography>

            <BullionMarginTable />
          </Paper>
        </Paper>
        {/* Section 3: Sell Out Time */}
        <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 4 }}>
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            {t("metals.sellOutTimeOfMetal")}
          </Typography>

          <Grid container spacing={2}>
            {/* Select Metal Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl
                fullWidth
                size="small"
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              >
                <InputLabel>{t("metals.selectMetal")}</InputLabel>
                <Select
                  label={t("metals.selectMetal")}
                  value={
                    sellOutMetal && sellOutPurity
                      ? `${sellOutMetal}|${sellOutPurity}`
                      : ""
                  }
                  onChange={(e) => {
                    const [metal, pur] = e.target.value.split("|");
                    setSellOutMetal(metal);
                    setSellOutPurity(pur);
                    let sel_metal = enabledMetal.find(
                      (item) => item.purity == pur && item.metalName == metal,
                    );
                    if (sel_metal) {
                      setSellOutTime(sel_metal?.sellOut);
                    }
                  }}
                >
                  {enabledMetal.map((item, idx) => (
                    <MenuItem
                      key={idx}
                      value={`${item.metalName}|${item.purity}`}
                    >
                      {item.metalName}-{item.karat}K-{item.purity}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Sell Out Time Textfield */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={t("metals.enterSellOutTimeHrs")}
                placeholder={t("metals.addTime")}
                type="number"
                size="small"
                value={sellOutTime}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    setSellOutTime(value);
                  }
                }}
                sx={{ minWidth: { xs: "210px", sm: "239px" } }}
                inputProps={{ min: 0, step: "any" }}
              />
            </Grid>

            {/* Add Button */}
            <Grid item xs={12} md={4}>
              {canCreateMetal && (
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: "#752ADA",
                    fontSize: "14px",
                    height: "40px",
                    textTransform: "none",
                  }}
                  onClick={handleUpdateSellOutTime}
                >
                  {t("metals.save")}
                </Button>
              )}
            </Grid>
          </Grid>
        </Paper>

        {/* Section 3: Redeem out Time */}
        <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 4 }}>
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            {t("metals.redeemOutTimeOfMetal")}
          </Typography>

          <Grid container spacing={2}>
            {/* Select Metal Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl
                fullWidth
                size="small"
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              >
                <InputLabel>{t("metals.selectMetal")}</InputLabel>
                <Select
                  label={t("metals.selectMetal")}
                  value={
                    redeemTimeOutMetal && redeemTimeOutPurity
                      ? `${redeemTimeOutMetal}|${redeemTimeOutPurity}`
                      : ""
                  }
                  onChange={(e) => {
                    const [metal, pur] = e.target.value.split("|");
                    setRedeemTimeOutMetal(metal);
                    setRedeemTimeOutPurity(pur);
                    let sel_metal = enabledMetal.find(
                      (item) => item.purity == pur && item.metalName == metal,
                    );
                    if (sel_metal) {
                      setRedeemTimeOut(sel_metal?.redeemTimeOut);
                    }
                  }}
                >
                  {enabledMetal.map((item, idx) => (
                    <MenuItem
                      key={idx}
                      value={`${item.metalName}|${item.purity}`}
                    >
                      {item.metalName}-{item.karat}K-{item.purity}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* redeem Out Time Textfield */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={t("metals.enterRedeemOutTimeHrs")}
                placeholder={t("metals.addTime")}
                type="number"
                size="small"
                value={redeemTimeOut}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d*$/.test(value)) {
                    setRedeemTimeOut(value);
                  }
                }}
                sx={{ minWidth: { xs: "210px", sm: "239px" } }}
                inputProps={{ min: 0, step: "any" }}
              />
            </Grid>

            {/* Add Button */}
            <Grid item xs={12} md={4}>
              {canCreateMetal && (
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    backgroundColor: "#752ADA",
                    fontSize: "14px",
                    height: "40px",
                    textTransform: "none",
                  }}
                  onClick={handleUpdateRedeemTimeOut}
                >
                  {t("metals.save")}
                </Button>
              )}
            </Grid>
          </Grid>
        </Paper>

        {/* Section 4: Add Quantity */}
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            {t("metals.addQuantityOfMetal")}
          </Typography>

          <Grid container spacing={2}>
            {/* Metal Dropdown */}
            <Grid item xs={12} md={4}>
              <FormControl
                fullWidth
                size="small"
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              >
                <InputLabel>{t("metals.selectMetal")}</InputLabel>
                <Select
                  label={t("metals.selectMetal")}
                  value={
                    metalBalance.metalName
                      ? `${metalBalance.metalName}|${metalBalance.purity}`
                      : ""
                  }
                  onChange={(e) => {
                    const [metal, pur] = e.target.value.split("|");
                    setMetalBalance({
                      ...metalBalance,
                      metalName: metal,
                      purity: pur,
                    });
                  }}
                >
                  {enabledMetal.map((item, idx) => (
                    <MenuItem
                      key={idx}
                      value={`${item.metalName}|${item.purity}`}
                    >
                      {item.metalName}-{item.karat}K-{item.purity}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Quantity */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={t("metals.addQuantityGms")}
                size="small"
                placeholder={t("metals.enterQuantity")}
                value={metalBalance.balance}
                onChange={(e) =>
                  setMetalBalance({ ...metalBalance, balance: e.target.value })
                }
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              />
            </Grid>

            {/* Rate per gram */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={t("metals.costPerGram")}
                size="small"
                placeholder={t("metals.enterRate")}
                value={metalBalance.rate}
                onChange={(e) =>
                  setMetalBalance({ ...metalBalance, rate: e.target.value })
                }
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              />
            </Grid>

            {/* Total without GST (readonly) */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={
                  taxType == "VAT"
                    ? t("metals.totalWithoutTax")
                    : t("metals.totalWithoutGst")
                }
                size="small"
                value={totalWithoutGst.toFixed(2)}
                InputProps={{ readOnly: true }}
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              />
            </Grid>

            {/* GST (readonly) */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={
                  taxType == "VAT" ? t("metals.taxLabel") : t("metals.gstLabel")
                }
                size="small"
                value={gst.toFixed(2)}
                InputProps={{ readOnly: true }}
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              />
            </Grid>

            {/* Total with GST (readonly) */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={
                  taxType == "VAT"
                    ? t("metals.totalWithTax")
                    : t("metals.totalWithGst")
                }
                size="small"
                value={totalWithGst.toFixed(2)}
                InputProps={{ readOnly: true }}
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              />
            </Grid>
          </Grid>
          <Box mb={4} display="flex" justifyContent="flex-end">
            {canCreateMetal && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#752ADA",
                  px: 4,
                  fontSize: "14px",
                  textTransform: "none",
                }}
                onClick={handleAddQuantity}
              >
                {t("metals.add")}
              </Button>
            )}
          </Box>
        </Paper>

        {/* Section 5: Remove Quantity */}
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            {t("metals.removeQuantityOfMetal")}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              {/* Dropdownlist of Select Metal  */}
              <FormControl
                fullWidth
                size="small"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              >
                <InputLabel>{t("metals.selectMetal")}</InputLabel>
                <Select
                  label={t("metals.selectMetal")}
                  value={
                    removeMetalBalance.metalName
                      ? `${removeMetalBalance.metalName}|${removeMetalBalance.purity}`
                      : ""
                  }
                  onChange={(e) => {
                    const [metal, pur] = e.target.value.split("|");
                    setRemoveMetal({
                      ...removeMetalBalance,
                      metalName: metal,
                      purity: pur,
                    });
                  }}
                >
                  {enabledMetal.map((item, idx) => (
                    <MenuItem
                      key={idx}
                      value={`${item.metalName}|${item.purity}`}
                    >
                      {item.metalName}-{item.karat}K-{item.purity}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Enter quantity gms to remove textfield */}
              <TextField
                fullWidth
                label={t("metals.enterQuantityToRemove")}
                size="small"
                placeholder={t("metals.addQuantity")}
                value={removeMetalBalance.balance}
                onChange={(e) =>
                  setRemoveMetal({
                    ...removeMetalBalance,
                    balance: e.target.value,
                  })
                }
                type="number"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* Rate per gram textfield */}
              <TextField
                fullWidth
                label={t("metals.ratePerGram")}
                placeholder={t("metals.addRate")}
                size="small"
                value={removeMetalBalance.rate}
                onChange={(e) =>
                  setRemoveMetal({
                    ...removeMetalBalance,
                    rate: e.target.value,
                  })
                }
                type="number"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              />
            </Grid>
            {/* Total without GST (readonly) */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                label={
                  taxType == "VAT"
                    ? t("metals.totalWithoutTax")
                    : t("metals.totalWithoutGst")
                }
                size="small"
                value={totalWithoutGstRemove.toFixed(2)}
                InputProps={{ readOnly: true }}
                sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              />
            </Grid>
          </Grid>
          <Box mb={4} display="flex" justifyContent="flex-end">
            {canDelete && (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#752ADA",
                  px: 4,
                  fontSize: "14px",
                  textTransform: "none",
                }}
                onClick={handleRemoveQuantity}
              >
                {t("metals.remove")}
              </Button>
            )}
          </Box>
        </Paper>
        {/* Remove button */}

        {/* Section 6: Download Report */}
        <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
          <Typography
            fontWeight={700}
            fontSize={24}
            mb={3}
            fontFamily={"Aeonik"}
          >
            {t("metals.downloadMetalBalanceReport")}
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              {/* Dropdownlist of SElect Metal */}
              <FormControl
                fullWidth
                size="small"
                sx={{
                  width: "100%", // ensures full width
                  minWidth: { xs: "210px", sm: "332px" }, // optional
                }}
              >
                <InputLabel>{t("metals.selectMetal")}</InputLabel>
                <Select
                  label={t("metals.selectMetal")}
                  value={bullion}
                  onChange={(e) => selectedBullion(e.target.value)}
                >
                  {enabledMetal.map((item, idx) => (
                    <MenuItem key={idx} value={`${item._id}`}>
                      {item.metalName}-{item.karat}K-{item.purity}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                gap={2}
              >
                {/* Start Date */}
                <DatePicker
                  label={t("metals.selectStartDate")}
                  value={startDate}
                  onChange={setStartDate}
                  format="dd/MM/yy"
                  slotProps={{ textField: { size: "small", fullWidth: true } }}
                />

                {/* End Date */}
                <DatePicker
                  label={t("metals.selectEndDate")}
                  value={endDate}
                  onChange={setEndDate}
                  format="dd/MM/yy"
                  slotProps={{ textField: { size: "small", fullWidth: true } }}
                />

                {/* Generate Button */}
                {canCreateMetal && (
                  <Button
                    variant="contained"
                    fullWidth={isMobile}
                    sx={{
                      backgroundColor: "#752ADA",
                      px: 3,
                      fontSize: "14px",
                      textTransform: "none",
                      height: "40px", // match Select height
                    }}
                    onClick={generateReport}
                  >
                    {t("metals.generate")}
                  </Button>
                )}
              </Box>
            </LocalizationProvider>
          </Grid>
        </Paper>

        {/* metal balance history1 section */}
        <Paper elevation={2} sx={{ borderRadius: 2, mb: 3, mt: 3 }}>
          {" "}
          <Typography
            fontWeight={700}
            p={3}
            fontSize={24}
            fontFamily={"Aeonik"}
          >
            {t("metals.metalBalanceHistory")}
          </Typography>
          <CardContent
            sx={{
              height: "580px",
              width: "100%",
            }}
          >
            <MetalBalanceHistory
              list={metalHistory}
              total={metalHistoryTotal}
            />
          </CardContent>
        </Paper>
      </Box>
    </Box>
  );
};

export default MetalManagement;
